import { Instance } from 'mobx-state-tree';
import { RoleDtoModelBase } from './RoleDtoModel.base';

/* The TypeScript type of an instance of RoleDtoModel */
export interface RoleDtoModelType extends Instance<typeof RoleDtoModel.Type> {}

/* A graphql query fragment builders for RoleDtoModel */
export { selectFromRoleDto, roleDtoModelPrimitives, RoleDtoModelSelector } from './RoleDtoModel.base';

/**
 * RoleDtoModel
 */
export const RoleDtoModel = RoleDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
